import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getRoles, unsetRoles } from "../../features/rolesSlice";
import MainContainer from "../../components/container/MainContainer";
import Modal from "../../components/modal/Modal";
import { openModal } from "../../features/modalSLice";
import AddRole from "./AddRole";
import Loading from "../../components/loading/Loading";
import LocationHeader from "../../components/header/LocationHeader";
import Table from "../../components/tables/Table";
import { getAllPermissions } from "../../features/configSlice";
import { useAuthorization } from "../../hooks/useAuthorization";
import loadStatus from "../../util/loadStatus";
import NetworkError from "../error/NetworkError";
import { useLocation } from "react-router-dom";

const Role = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { isAuthorized } = useAuthorization();
  const roles = useSelector((state) => state.roles.data);
  const modalContent = useSelector((state) => state.modal.content);
  const rolesLoad = useSelector((state) => state.roles.load.getRoles);
  const allPermsLoad = useSelector(
    (state) => state.config.load.getAllPermissions
  );

  const columns = [
    { id: "num", text: "Num" },
    { id: "name", text: "Role" },
    { id: "color", text: "Color" },
    // { id: "action", text: "Actions" },
  ];

  const openRoleModal = () => {
    dispatch(openModal(<AddRole />));
  };

  useEffect(() => {
    dispatch(getRoles());
    dispatch(getAllPermissions());
    return () => {
      dispatch(unsetRoles());
    };
  }, []);

  if (rolesLoad === loadStatus.loading || allPermsLoad === loadStatus.loading) {
    return <Loading />;
  }

  if (rolesLoad === loadStatus.error || allPermsLoad === loadStatus.error) {
    return <NetworkError to={location.pathname} />;
  }

  return (
    <>
      <Modal>{modalContent}</Modal>

      <MainContainer>
        <LocationHeader
          action={openRoleModal}
          links={[]}
          title="Roles"
          authorized={isAuthorized("communities", "create")}
        />

        <main className="table-container">
          <Table columns={columns} data={roles} link />
        </main>
      </MainContainer>
    </>
  );
};

export default Role;
